<div class="emoticons-container">
  <div class="emoticons-header">
    @if (emoticonsPallete.length > 0) {
    <div class="emoticon-button pointer"(click)="isEmoticonsPalleteVisible = !isEmoticonsPalleteVisible">
      <img src="../../assets/vote.png">
    </div>
    }
    <div class="emoticons">
      @for (emoticon of groupedEmoticons; track emoticon.symbol) {
        @if (emoticon.isUserEmoticonAlso == true) {
          <div class="emoticon-item pointer" (click)="deleteEmoticon(emoticon.symbol)">{{emoticon.symbol}} {{emoticon.count}}</div>
        } @else {
          <div class="emoticon-item pointer">{{emoticon.symbol}} {{emoticon.count}}</div>
        }
      }
    </div>
  </div>
  @if (isEmoticonsPalleteVisible) {
    <div class="emoticons-pallete pointer">
      @for (emoticon of emoticonsPallete; track emoticon.name) {
        <span class="emoticon-item pointer" (click)="addEmoticon(emoticon.name, emoticon.symbol)">{{emoticon.symbol}}</span>
      }
    </div>
  }
</div>
